export function focusOnElement(element: HTMLElement): void {
  if (element) {
    element.scrollIntoView({ behavior: 'auto', block: 'center' });
    // Adding setTimeout to avoid auto-opening dropdowns on mobile
    setTimeout(() => {
      element.focus({ preventScroll: true });
    }, 0);
  }
}

export default focusOnElement;
